<template>
  <div class="sky-network-port-tags-custom">
    <el-tag
      class="sky-network-port-attribute-tag"
      closable
      v-for="(tag, index) in tagArr"
      :key="index"
      @close="handleCloseTag(tag, index)"
      >{{ tag }}</el-tag
    >
    <el-select
      class="sky-network-port-attribute-tag-select"
      allow-create
      v-model="newTag"
      filterable
      @change="changeToSelectNewTag"
      placeholder="请输入端口并选中添加"
    >
      <el-option
        v-for="item in defaultTagArr"
        :key="item"
        :label="item.label"
        :value="item.value"
        :disabled="item.disabled"
      >
      </el-option>
    </el-select>
  </div>
</template>
<script type="text/babel">
import { FormItem, Select, Option, Tag } from 'element-ui'

export default {
  name: 'SkyNetworkPortTagCustom',
  components: {
    [FormItem.name]: FormItem,
    [Tag.name]: Tag,
    [Select.name]: Select,
    [Option.name]: Option
  },
  props: {
    values: {
      type: Array,
      default() {
        return []
      }
    }
  },
  watch: {
    values: {
      handler: function(newValue, oldValue) {
        this.values = newValue
        this.tagArr = newValue
        if (!newValue) {
          this.values = []
          this.tagArr = []
        }

        for (const iterator of this.defaultTagArr) {
          var dfd = this.tagArr.indexOf(iterator.label)
          if (dfd !== -1) {
            iterator.disabled = true
          } else {
            iterator.disabled = false
          }
        }
        if (newValue.length !== oldValue.length) {
          this.$emit('selectChange', newValue)
        }
      },
      deep: true
    }
  },
  data() {
    return {
      tagArr: [],
      defaultTagArr: [],
      newTag: null
    }
  },
  computed: {
    tendsRule() {
      const validatorBranch = (rule, value, callback) => {
        this.checkList = []
        if (!this.checkList.length) {
          callback()
        }
      }
      return [[{ validator: validatorBranch, trigger: ['blur', 'change'] }]]
    }
  },
  created() {
    if (!this.values) {
      this.values = []
      this.tagArr = []
    } else {
      this.tagArr = this.values
    }
  },
  mounted() {},
  methods: {
    handleCloseTag(tag, index) {
      this.tagArr.splice(index, 1)
      this.value = this.tagArr
    },
    changeToSelectNewTag(newValue) {
      const portRegex = /^([1-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-5]{2}[0-3][0-5]|[1-5]\d{0,3})$/
      if (!portRegex.test(newValue)) {
        this.newTag = null
        return
      }
      this.tagArr.push(newValue)
      this.values = this.tagArr
      this.newTag = null
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

@include b(network-port-tags-custom) {
  .sky-network-port-attribute-tag-select {
    width: 220px;
    .el-input__inner {
      border-radius: 20px;
    }
  }
  .sky-network-port-attribute-tag {
    margin-left: 8px;
    margin-bottom: 4px;
  }
}
</style>
